import { styled } from "@mui/material/styles";
import TableCell, { tableCellClasses } from "@mui/material/TableCell";
import TableRow from "@mui/material/TableRow";

export const Root = styled("div")(({ theme }) => ({
  [theme.breakpoints.up("sm")]: {
    width: "auto", //500
    fontFamily: "Roboto",
  },
  [theme.breakpoints.down("sm")]: {
    width: "auto", //400
    fontFamily: "Roboto",
  },

  [theme.breakpoints.down("md")]: {
    width: "auto",
    fontFamily: "Roboto",
  },
  [theme.breakpoints.up("md")]: {
    width: "auto",
    fontFamily: "Roboto",
  },
  [theme.breakpoints.down("lg")]: {
    width: "auto", //1200
    fontFamily: "Roboto",
  },

  [theme.breakpoints.up("lg")]: {
    width: "auto", //1000
    fontFamily: "Roboto",
  },
}));
export const boxStyle = {
  marginTop: "3px",
  borderShodow: "3",
  textAlign: "left",
  fontSize: "32px",
  fontFamily: "Roboto",
  marginRight: "35px",
};
export const boxStyle2 = {
  marginLeft: "15px",
  marginTop: "-1px",
  borderShodow: "3",
  textAlign: "left",
  fontSize: "32px",
  fontFamily: "Roboto",
};

export const boxStyle3 = {
  marginLeft: "250px",
  marginTop: "5px",
  borderShodow: "3",
  textAlign: "left",
  fontSize: "32px",
  fontFamily: "Roboto",
};

export const StyledTableCell = styled(TableCell)(({ theme }) => ({
  [`&.${tableCellClasses.head}`]: {
    backgroundColor: theme.palette.common.white,
    color: theme.palette.common.black,
  },
  [`&.${tableCellClasses.body}`]: {
    fontSize: 14,
  },
}));

export const StyledTableRow = styled(TableRow)(({ theme }) => ({
  // "&:nth-of-type(odd)": {
  //   backgroundColor: theme.palette.action.hover,
  // },
  // hide last border
  "&:last-child td, &:last-child th": {
    border: 0,
  },
}));
const drawerWidth = 240;
export const drawer = {
  width: drawerWidth,
  flexShrink: 0,

  "& .MuiDrawer-paper": {
    width: drawerWidth,
    boxSizing: "border-box",
    background: "#151B54",
    color: "white",
  },
  display: "flex",
  flexDirection: "column",
  justifyContent: "space-between",
  alignItems: "flex-end",
  justifyContent: "flex-end",
};

export const boxline = {
  display: "flex",
  marginTop: "5px",
};
export const form_add = {
  marginTop: "0.5rem",
};
export const form_add2 = {
  marginTop: "0.5rem",
  width: "100%",
  maxWidth: "1000px",
};

export const searchStyle = {
  display: "flex",
  float: "right",
  justifyContent: "flex-end",
  alignItems: "flex-end",
};

export const listDesign = {
  fontFamily: "Roboto",
  fontSize: "clamp(18px, 4vw, 25px)",
};
export const buttonPosition = {
  display: "flex",
  justifyContent: "flex-end",
  alignItems: "flex-end",
};
export const buttonPosition2 = {
  display: "flex",
  justifyContent: "flex-end",
  alignItems: "flex-end",
};
export const buttonStyle = {
  minWidth: "150px",
  width: "clamp(150px, 20vw, 200px)",
  marginTop: "0.625rem",
  marginLeft: "0.625rem",
  padding: "clamp(0.5rem, 2vw, 0.75rem)",
  fontSize: "clamp(12px, 2vw, 16px)",
};
export const buttonStyle2 = {
  minWidth: "150px",
  width: "clamp(150px, 20vw, 200px)",
  marginTop: "0.625rem",
  padding: "clamp(0.5rem, 2vw, 0.75rem)",
  fontSize: "clamp(12px, 2vw, 16px)",
};
export const buttonStyle3 = {
  minWidth: "120px",
  width: "clamp(120px, 15vw, 150px)",
  marginTop: "0.625rem",
  padding: "clamp(0.5rem, 2vw, 0.75rem)",
  fontSize: "clamp(12px, 2vw, 16px)",
};
export const max_width = "50px";
export const lebelStyle = {
  fontFamily: "Roboto",
  fontSize: "clamp(12px, 2vw, 15px)",
};

export const cardStyle = { padding: "1rem", marginTop: "0.625rem" };
export const inputstyle = { fontSize: "clamp(16px, 3vw, 20px)" };
export const logoStyle = { width: "clamp(10%, 15vw, 15%)" };
export const logoStyle2 = {
  width: "clamp(60%, 80vw, 80%)",
  marginLeft: "clamp(10px, 2vw, 20px)",
  marginTop: "clamp(8px, 1vw, 12px)",
  marginBottom: "clamp(8px, 1vw, 10px)",
  borderTop: "1px solid none",
  padding: "clamp(8px, 1.5vw, 10px)",
};
export const zewalogo_customer = {
  width: "clamp(50%, 60vw, 60%)",
  marginLeft: "clamp(20px, 3vw, 40px)",
  marginTop: "clamp(15px, 2vw, 20px)",
  borderTop: "1px solid none",
  padding: "clamp(5px, 1.5vw, 7px)",
};
export const logout = { display: "flex", alignItems: "flex-end" };
export const headerStyle = { paddingLeft: "clamp(8px, 1.5vw, 10px)" };
export const pageNo = {
  display: "block",
  marginLeft: "auto",
  marginRight: "auto",
  textAlign: "center",
  alignItems: "center",
};

export const textfield = {
  margin: "0.5rem",
  width: "100%",
  maxWidth: "400px",
};
export const crossHubAction = {
  color: "white",
  backgroundColor: "red",
  height: "25px",
  width: "25px",
  borderRadius: "50%",
  margin: "2px",
};
